module.exports = __webpack_public_path__ + "static/media/PNG.fe2f94f3.svg";